import { ApiClientError } from "../../types/api";

// backend/prime/accounts/opening_words.py ACCOUNT_IN_OTHER_BOOKS: the held account's 409.
export const ACCOUNT_IN_OTHER_BOOKS = "ACCOUNT_IN_OTHER_BOOKS";

/**
 * The held account's `last6` when `err` is the 409 ACCOUNT_IN_OTHER_BOOKS,
 * else null. Its `details.account` is the account view; "" when that view
 * names no `last6`.
 */
export function heldAccountLast6(err: unknown): string | null {
  if (!(err instanceof ApiClientError) || err.code !== ACCOUNT_IN_OTHER_BOOKS) return null;
  // details is typed for field errors; this refusal carries the account view there instead.
  const details = err.details as Record<string, unknown> | undefined;
  const account = details?.account;
  if (typeof account !== "object" || account === null) return "";
  const last6 = (account as Record<string, unknown>).last6;
  return typeof last6 === "string" ? last6 : "";
}
